(function () {
  const target = document.querySelector("#buy-button-submit");
  const floatingBuyButton = document.querySelector("#floating-buy-button");

  const cb = (entries) => {
    const entry = entries[0];
    const top = entry.boundingClientRect.top;

    if (entry.isIntersecting === false && top < 0) {
      // when the user has scrolled past (below) the static add-to-cart-button
      floatingBuyButton.classList.remove("translate-y-16");
      floatingBuyButton.classList.add("translate-y-0");
    } else {
      floatingBuyButton.classList.add("translate-y-16");
      floatingBuyButton.classList.remove("translate-y-0");
    }
  };

  const options = {
    rootMargin: "0px",
    threshold: 1.0,
  };
  const observer = new IntersectionObserver(cb, options);
  observer.observe(target);
})();
